export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_6.2-f9a6d16d7f570eadcc2d62b102fd6546.svg";